export default __webpack_public_path__ + "static/media/Icon material-account-box.26e4df7d.svg";